/**
 * Enum for attachment intended use.
 * Used to differentiate attachments by their purpose within the same entity.
 */
export enum AttachmentIntendedUse {
  /** Icon image for widgets (e.g., ExternalLink icon) */
  WidgetIcon = 'widget_icon',
  /** Content image for widgets (e.g., Announcement image) */
  WidgetImage = 'widget_image',
}
